import { MdDriveFolderUpload, MdEmojiTransportation } from 'react-icons/md';

const tiles = [
  {
    sNo: 1,
    link: '/common/company_roles_responsibilities_listOfProcedures?documentType=clause7ListOfProcedure',
    isLink: true,
    icon: <MdDriveFolderUpload size="5rem" color="#003566" />,
    p: 'LIST OF',
    span: 'PROCEDURE',
    isIcon: true,
  },
  // {
  //   sNo: 1,
  //   link: '/admin/supplier_list?filter=createdAt',
  //   isLink: true,
  //   p: 'MASTER LIST OF',
  //   span: 'SUPPLIER',
  //   isIcon: true,
  //   icon: <MdEmojiTransportation size="5rem" color="#135089" />,
  // },
];

export default tiles;
